import { Component } from "../../components/base/Component";
import { ICfa } from "../../models/ICfa";
import { API } from "../../util/API";
import { ComponentFactory } from "../../services/ComponentFactory";

export class YextLocationIframe extends Component {
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);

		window.addEventListener("message", this.yextMessage, false);
	}

	async yextMessage(evt: Event) {
		evt.preventDefault();

		const whatever = await API.getReq("/locationredirectcheck", "00070");

		console.log(whatever);

		if (evt.data.storeId !== undefined) {
			// 1. Send Store Id to a new API call to return com, ca, or pr
			//	  and location url.
			// 2. If value returned != current site, open the existing
			//    "leaving site" modal. Add location URL to the proceed btn
			// 3. If value returned == current site, redirect to the URL
		}
	}
}

ComponentFactory.registerComponent("YextLocationIframe", YextLocationIframe);
